import React from "react";
import AllCategoriesThree from "./CategoryModule/AllCategoriesThree";

const CategoriesThree = () => {
  return (
    <div>
      <AllCategoriesThree />
    </div>
  );
};

export default CategoriesThree;
